import { render, staticRenderFns } from "./jurnalfrm.vue?vue&type=template&id=16a1a26d"
import script from "./jurnalfrm.vue?vue&type=script&lang=js"
export * from "./jurnalfrm.vue?vue&type=script&lang=js"
import style0 from "./jurnalfrm.vue?vue&type=style&index=0&id=16a1a26d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports